import moment from 'moment-timezone';

const DEFAULT_TIMEZONE = 'America/Chicago';

/**
 * Use this for timestamps returned from GraphQL
 * @param   {String}    timestamp   Unix ms (e.g. 1663351671000)
 * @param   {String}    timezone
 * @returns {String}                M/D/YYYY
 */
export const convertUnixMsToDateInTimezone = (timestamp, timezone) => {
    timezone = timezone ?? DEFAULT_TIMEZONE;

    const convertedTime = moment(timestamp, 'x').tz(timezone);
    return formatDateForDisplay(convertedTime);
}

/**
 * Use this for timestamps sent to GraphQL
 * Converts midnight in the given timezone to UTC
 * @param   {Date}      date
 * @param   {String}    timezone
 * @returns {String}    ISO String (e.g. 2022-09-19T05:00:00Z)
 */
export const convertDateToUTC = (date, timezone) => {
    timezone = timezone ?? DEFAULT_TIMEZONE;

    const dateOnly = date.toISOString().slice(0, 10);
    const dateInTimezone = moment.tz(
        `${dateOnly} 00:00:00`,
        'YYYY-MM-DD HH:mm:ss',
        timezone,
    );

    return dateInTimezone.tz('UTC').format();
}

/**
 * @param   {String}    timezone
 * @returns {String}    M/D/YYYY 
 */
export const getCurrentDateInTimezone = (timezone) => {
    timezone = timezone ?? DEFAULT_TIMEZONE;

    const now = moment().tz(timezone);
    return formatDateForDisplay(now);
}

/**
 * @param   {String|Date|Moment}    date
 * @returns {String}                M/D/YYYY
 */
export const formatDateForDisplay = (date) => {
    if (typeof date === 'string') {
        return moment(date, 'YYYY-MM-DD').format('M/D/YYYY');
    }

    return moment(date).format('M/D/YYYY');
}
